// import moment from 'moment';
// import _ from 'lodash';
import db from '../../config/databases/forms';
import refreshFormsList from './refreshFormsList';
// import getFormLocal from './getFormLocal'

// Update form status
export default async function updateFormStatus(formId, status, statusType = 'status') {
  const _formId = parseInt(formId, 10);
  await db.table('forms').update(_formId, { [statusType]: status });
  // const form = await getFormLocal(formId)
  // if(statusType !=="imageStatus"){
  //     const logpath = statusType==="status" ? "log" : "logLS"
  //     const log = _.get(form, logpath, [])
  //     log.push({[status] : moment().format('YYYY-MM-DD HH:mm:ss')});
  //     await db.table('forms').update(formId, {[logpath] : log})
  // }
  refreshFormsList();
}
